<template>
  <div class="filter-group">
    <div class="filter-group__filters">
      <slot></slot>
      <component
        v-for="(filterData, index) in filters"
        :key="index"
        :is="filterData.component"
        :filterData="filterData"
        @removeFilter="removeFilter"
      />
      <slot name="end"></slot>
    </div>
    <div class="filter-group__type-picker" v-if="isTypePickerVisible" :key="0">
      <sidebar-item
        v-for="(field, index) in filteredFields"
        :key="index"
        class="list-group-item-action filter-group__type-picker__type"
        @click="addFilter(field)"
      >
        {{ field.label }}
        <template #icon>
          <b-icon
            icon="fonts"
            v-if="field.filter.component === filterComponents.StringFilter"
          />
          <b-icon
            icon="calendar-date"
            v-else-if="field.filter.component === filterComponents.DateFilter"
          />
          <b-icon
            icon="calculator"
            v-else-if="
              field.filter.component === filterComponents.NumericFilter
            "
          />
          <b-icon
            icon="check"
            v-else-if="
              field.filter.component === filterComponents.ValuePickerFilter
            "
          />
        </template>
      </sidebar-item>
    </div>
    <div class="filter-group__add-filter-button" v-else :key="1">
      <p @click="isTypePickerVisible = true">Добавить фильтр</p>
    </div>
  </div>
</template>

<script>
import SidebarItem from "@/components/Layout/Sidebars/SidebarItems/SidebarItem";
import DateFilter from "@/components/Tables/Filters/DateFilter";
import NumericFilter from "@/components/Tables/Filters/NumericFilter";
import StringFilter from "@/components/Tables/Filters/StringFilter";
import ValuePickerFilter from "@/components/Tables/Filters/ValuePickerFilter";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { SidebarItem },
  props: {
    fields: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: false
    },
    storeName: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      isTypePickerVisible: false,
      initialized: false,
      filters: [],
      filterComponents: {
        DateFilter,
        NumericFilter,
        StringFilter,
        ValuePickerFilter
      }
    };
  },
  methods: {
    ...mapActions("filters", ["setFilters"]),
    addFilter(field) {
      this.isTypePickerVisible = false;
      let filterComponent = field.filter.component;

      if (filterComponent !== undefined) {
        this.filters.push({
          component: filterComponent,
          field,
          handler: () => true
        });
      }
    },
    removeFilter(filterData) {
      if (this.filters.indexOf(filterData) !== -1)
        this.filters.splice(this.filters.indexOf(filterData), 1);
    },
    initialize() {
      if (!this.initialized) {
        if (
          this.storeName !== undefined &&
          this.storeFilters(this.storeName) !== undefined
        )
          this.filters = this.storeFilters(this.storeName);
        else {
          this.fields
            .filter(
              field =>
                field.filter !== undefined &&
                field.filter.initialState.applyOnInit
            )
            .forEach(field => {
              this.addFilter(field);
            });
        }
        this.initialized = true;
      }
    }
  },
  computed: {
    ...mapGetters("filters", {
      storeFilters: "filters"
    }),
    filteredItems: ({ items, filters }) =>
      filters.length > 0
        ? items.filter(item => !filters.some(({ handler }) => !handler(item)))
        : items,
    filteredFields: ({ fields }) =>
      fields.filter(field => field.filter !== undefined)
  },
  created() {
    this.initialize();
    this.$emit("input", this.filteredItems);
  },
  watch: {
    fields: {
      deep: true,
      handler() {
        this.initialize();
      }
    },
    filters: {
      deep: true,
      handler(val) {
        if (this.storeName !== undefined)
          this.setFilters({ name: this.storeName, filters: val });
      }
    },
    filteredItems: {
      deep: true,
      handler(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>

<style lang="scss">
.filter-group {
  &__type-picker {
    &__type {
      cursor: pointer;
    }
  }

  &__add-filter-button {
    text-align: center;
    color: #007bff;

    & > p {
      display: inline-block;
      border-bottom: solid 1px transparent;
    }

    & > p:hover {
      border-bottom: solid 1px #0060c7;
      color: #0060c7;
      cursor: pointer;
    }
  }
}
</style>
